module.exports = __webpack_public_path__ + "static/media/instaActive.d6d34df1.png";